import { Store } from 'redux';
import { authDispatch } from './auth';

export const initialDispatches = (store: Store) => {
  // authDispatch(store);
};
